import React from 'react';
import { MultiSelectViewModel } from './multi-select.view-model';

const MultiSelectCtx = React.createContext<MultiSelectViewModel<any> | undefined>(undefined);

export const MultiSelectProvider = ({
  vm,
  children,
}: {
  vm: MultiSelectViewModel<any>;
  children: React.ReactNode;
}) => {
  return <MultiSelectCtx.Provider value={vm}>{children}</MultiSelectCtx.Provider>;
};

export const useMultiSelect = () => {
  const ctx = React.useContext(MultiSelectCtx);
  if (!ctx) {
    throw new Error('useMultiSelect must be used inside MultiSelectProvider');
  }
  return ctx;
};
